import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['select'];

  // Apply first select value to all other selects
  applyToAll(event) {
    event.preventDefault();

    const selects = this.selectTargets;

    if (selects.length === 0) return;

    const firstValue = selects[0].value;

    if (!firstValue) {
      alert('最初の従業員の金額を選択してください');

      return;
    }

    selects.slice(1).forEach((select) => {
      select.value = firstValue;
      this.highlightSelect(select);
    });
  }

  // Copy value from the previous row
  sameAsAbove(event) {
    event.preventDefault();

    const currentRow = event.currentTarget.closest('tr');
    const currentSelect = currentRow.querySelector('select');
    const previousRow = currentRow.previousElementSibling;

    if (previousRow) {
      const previousSelect = previousRow.querySelector('select');

      if (previousSelect && previousSelect.value) {
        currentSelect.value = previousSelect.value;
        this.highlightSelect(currentSelect);
      }
    }
  }

  // Visual feedback when value is copied
  highlightSelect(select) {
    select.classList.add('is-valid');

    setTimeout(() => {
      select.classList.remove('is-valid');
    }, 1500);
  }
}
